const styles = {
  container: {
    color: '#3b3b3b',
  },
  error: {
    fontWeight: 600,
    color: '#f00',
  },
  listContainer: {
    height: '500px',
    maxHeight: 'calc(100vh - 255px)',
    overflow: 'auto',
    borderRadius: '3px',
    display: 'flex',
    flexDirection: 'column',
  },
  listWrapper: {
    backgroundColor: '#f1f1f1',
    padding: '8px 16px',
    // height: '100%',
    // maxHeight: 'calc(100% - 16px)',
    borderRadius: '3px',
    marginTop: '12px',
    marginBottom: '12px',
    flex: 1,
    overflow: 'hidden',
  },
  listWrapperFlexible: {
    backgroundColor: '#f1f1f1',
    padding: '8px 16px',
    // height: '100%',
    maxHeight: '30%',
    borderRadius: '3px',
    marginTop: '12px',
    marginBottom: '12px',
    overflowX: 'hidden',
    overflowY: 'scroll',
  },
  listWrapperScroll: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    height: 'calc(100% - 30px)',
  },
  list: {
    height: '410px',
    overflowY: 'hidden',
    overflowX: 'hidden',
    maxHeight: 'calc(100% - 40px)',
    padding: '8px',
  },
  cardContainer: {
    backgroundColor: '#fff',
    padding: '4px',
    cursor: 'pointer',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: '3px',
    margin: '4px',
  },
  cardSelected: {
    borderColor: '#297a48',
  },
  cardDisabled: {
    backgroundColor: '#ccc',
    cursor: 'not-allowed',
  },
  cardAvatar: {
    maxHeight: '50px',
    display: 'block',
    maxWidth: '50px',
    margin: 'auto',
    padding: '4px',
  },
  cardLabel: {
    fontWeight: '600',
    fontSize: '14px',
  },
  cardSubtitle: {
    fontSize: '13px',
    fontStyle: 'italic',
  },
  grayText: {
    color: '#848484',
  },
  dialogPaper: {
    padding: '24px',
  },
  dialogTitle: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '20px',
  },
  dialogContent: {
    margin: '8px 0px',
    color: '#bfbfbf',
  },
  dialogButton: {
    padding: '4px 48px',
  },
};

export default styles;
